'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const RootWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1t0rl7h-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;flex-grow:1;padding-bottom:", "px;position:", ";", ""], _ref => {
  let {
    s
  } = _ref;
  return (s === null || s === void 0 ? void 0 : s.paddingBottom) ?? 100;
}, _ref2 => {
  let {
    s
  } = _ref2;
  return (s === null || s === void 0 ? void 0 : s.position) ?? 'relative';
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.bodytextDefaultNone;
});
const Wrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1t0rl7h-1"
})(["display:flex;justify-content:center;gap:20px;width:80%;padding-top:50px;"]);
const UserActions = styled__default["default"].div.withConfig({
  componentId: "sc-1t0rl7h-2"
})(["display:flex;flex-direction:column;align-items:center;gap:20px;min-width:50%;width:100%;"]);
styled__default["default"].div.withConfig({
  componentId: "sc-1t0rl7h-3"
})(["border-top:1px solid #ccc;"]);
const BackButtonWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1t0rl7h-4"
})(["position:absolute;top:20px;left:0;padding:20px;"]);

exports.BackButtonWrapper = BackButtonWrapper;
exports.RootWrapper = RootWrapper;
exports.UserActions = UserActions;
exports.Wrapper = Wrapper;
